import React from "react";
import moment from "moment";
import type { IFuneralDetail } from "service/interface/funeral";

interface Props {
  data: IFuneralDetail;
}

export function ContactInfoTable({ data }: Props) {
  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          신청 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            지역
          </div>
          <div className="flex h-full w-[318px] items-center px-[12px] text-M3 text-gray-5">
            {data.region}
          </div>
          <div className="flex h-full w-[164px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            이미 준비된 물품
          </div>
          <div className="flex h-full w-[303px] items-center gap-[48px] px-[24px] text-M3 text-gray-5">
            {data.preparedItems?.split(";")?.join(", ")}
          </div>
        </div>
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            예상 조문객 수
          </div>
          <div className="flex h-full w-[318px] items-center px-[12px] text-M3 text-gray-5">
            {data.expectedVisitors}
          </div>
        </div>
        <div className="flex h-[190px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            기타
          </div>
          <div className="flex h-full w-[790px] items-center px-[12px] text-M3 text-gray-5">
            <textarea
              readOnly
              value={data.etc}
              className="m-0 h-[166px] w-full resize-none border-none p-0 focus:ring-white"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
